import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { DocumentService } from 'src/app/services/document.service';
import { LoanAgreementRequest } from 'src/app/shared/models/documents/loan-agreement-request';
import { UserIdentifiers } from 'src/app/shared/models/users/user-identifiers';
import { Document } from 'src/app/shared/models/documents/document';
import { ModalDirective } from 'angular-bootstrap-md';

@Component({
  selector: 'app-create-document',
  templateUrl: './create-document.component.html',
  styleUrls: ['./create-document.component.scss'],
})
export class CreateDocumentComponent implements OnChanges, OnDestroy {
  @ViewChild('loanAgreementModal', { static: true }) loanAgreementModal: ModalDirective;
  @Input() documentType: number;
  @Input() lenderFullName: string;
  @Input() borrowerFullName: string;
  @Input() userIdentifiers: UserIdentifiers;
  @Input() showModal: boolean = false;
  @Output() modalClosed = new EventEmitter<void>();
  @Output() errorOccurred = new EventEmitter<any>();
  @Output() documentAdded = new EventEmitter<Document>();

  submitting: boolean = false;

  private subs: Subscription[] = [];

  loanAgreementForm!: FormGroup;
  constructor(
    private fb: FormBuilder,
    private documentService: DocumentService
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['documentType']) {
      this.loanAgreementForm = this.fb.group({
        Amount: [null, [Validators.required, Validators.min(0)]],
        DateOfTransaction: ['', [Validators.required]],
      });
    }

    if (changes['showModal'] && changes['showModal'].currentValue !== changes['showModal'].previousValue) {
      this.showHideModal(changes['showModal'].currentValue);
    }
  }

  submitHandler(): void {
    if (this.loanAgreementForm.invalid) {
      this.loanAgreementForm.markAllAsTouched();
      return;
    }

    this.submitting = true;
    const loanRequest = this.buildLoanRequest();

    const sub = this.documentService.SendDocumentData(loanRequest).subscribe({
      next: (doc: Document) => {
        this.documentAdded.emit(doc);
        this.submitting = false;
        this.modalClosed.emit();
        this.loanAgreementModal.hide();
      },
      error: (err) => {
        this.errorOccurred.emit(err);
        this.submitting = false;
        this.modalClosed.emit();
        this.loanAgreementModal.hide();
      },
    });
    this.subs.push(sub);
  }

  showHideModal(toggle: boolean) {
    if (toggle != null) {
      this.showModal = toggle;
    }
    if (!this.showModal) {
      this.modalClosed.emit();
    }
    if (this.showModal) {
      this.loanAgreementModal.show();
    }
  }

  ngOnDestroy(): void {
    this.subs.forEach((s) => s.unsubscribe());
  }

  private buildLoanRequest(): LoanAgreementRequest {
    const loanForm = this.loanAgreementForm.value;
    const loanRequest = new LoanAgreementRequest();

    loanRequest.$type = 'Trakly.Models.API.Document.LoanAgreementDocRequest, Trakly.Models';
    loanRequest.userIdentifiers = this.userIdentifiers;
    loanRequest.amount = loanForm.Amount;
    loanRequest.dateOfTransaction = loanForm.DateOfTransaction;

    return loanRequest;
  }
}
